import React from 'react';
import { Col, Form, FormGroup, Label, Input, Row, FormFeedback } from "reactstrap";

export const FormMicCatalogs = (props) => {
    const {
        handleInputChange, name, description, estatus
    } = props;




    return (
        <Form className='pt-3' role="form" >

            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Nombre<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className='input-admision'
                            type='text'
                            name="name"
                            onChange={handleInputChange}
                            value={name}
                            autoComplete="off"
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="8">
                    <FormGroup>
                        <Label className='label-admision'>Descripción <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className='input-admision'
                            type='text'
                            name="description"
                            onChange={handleInputChange}
                            value={description}
                            autoComplete="off"
                        />
                        <FormFeedback>Minimo 2 caracteres</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className=" mt-2">¿Activar Norma? </Label>

                        <Label className="switch">
                            <Input type="checkbox" name="estatus" onChange={handleInputChange} checked={estatus} />
                            <span className="slider round"></span>
                        </Label>
                    </FormGroup>
                </Col>
            </Row>
        </Form >
    )
}